import { FC, useState } from "react";
import { Column, Row } from "../../../components/containers";
import { useAlertStore, useThemeStore, useUserStore } from "../../../stores";
import { Heading } from "../../../components/typography";
import {
  AlignItems,
  JustifyContent,
} from "../../../components/containers/types";
import { TextInput } from "../../../components/inputs";
import { Color } from "../../../types";
import ColorPicker from "../../../components/color-picker";
import { Button } from "../../../components/buttons";
import { TagApi } from "../../../api";

const AddTag: FC = () => {
  const theme = useThemeStore((s) => s.theme);
  const [tagName, setTagName] = useState<string>("");
  const [tagColor, setTagColor] = useState<Color>("#522258");
  const [loading, setLoading] = useState<boolean>(false);
  const hasUserAccess = useUserStore((s) => s.hasUserAccess);

  const pushAlert = useAlertStore((s) => s.pushAlert);

  const onAdd = (): void => {
    if (!hasUserAccess(["Admin", "AddEditCustomer"]))
      return pushAlert("دسترسی غیر مجاز", "error");
    if (!tagName || !tagColor)
      return pushAlert("نام و رنگ باید انتخاب شوند", "error");
    setLoading(true);
    TagApi.addTag(tagName, tagColor)
      .then(() => {
        setTagName("");
        pushAlert("عملیات موفقیت آمیز");
      })
      .catch((err) => {
        pushAlert(err.msg || "unknown error", "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Row
      style={{
        width: "100%",
        margin: "1rem",
        borderRadius: 15,
      }}
      gap={50}
      justifyContent={JustifyContent.Start}
    >
      <Column gap={10} alignItems={AlignItems.Start} style={{ width: "100%" }}>
        <Heading color={theme.textOnBg} size={20}>
          تعریف تگ مشتریان
        </Heading>
        <Column
          style={{
            width: "calc(100% - 4rem)",
            borderRadius: 15,
            padding: "2rem",
          }}
          gap={30}
          background={theme.overlay}
          alignItems={AlignItems.Start}
        >
          <Row
            style={{ width: "100%" }}
            alignItems={AlignItems.Start}
            className="add-tag-con"
            gap={20}
          >
            <TextInput label="نام تگ" value={tagName} setValue={setTagName} />
            <ColorPicker
              label="رنگ تگ"
              value={tagColor}
              setValue={setTagColor}
            />
          </Row>
          <Button
            loading={loading}
            onClick={onAdd}
            background={theme.primary}
            color={theme.textOnprimary}
          >
            افزودن
          </Button>
        </Column>
      </Column>
    </Row>
  );
};

export default AddTag;
